function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagJapan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 473.68 473.68",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 236.85,
    cy: 236.85,
    r: 236.83
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 236.85,
    cy: 236.85,
    r: 236.83
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFECEC"
    },
    d: "M460.143,157.874c-0.026-0.075-0.049-0.138-0.075-0.206C429.756,72.2,351.789,9.319,258.109,0.972 c36.248,19.872,46.834,82.832,56.109,156.901c6.335,50.593,6.376,106.339,0.12,156.995c-9.196,74.47-19.827,137.874-56.228,157.829 c93.848-8.362,171.927-71.46,202.12-157.156c0.079-0.228,0.146-0.453,0.228-0.673c8.526-24.438,13.219-50.682,13.219-78.026 C473.677,209.139,468.879,182.573,460.143,157.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F2F2"
    },
    d: "M326.412,157.874c-9.27-74.07-32.052-137.029-68.303-156.901C251.097,0.352,244.007,0,236.835,0 C133.806,0,46.187,65.802,13.608,157.668c-0.026,0.067-0.049,0.131-0.075,0.206C4.798,182.573,0,209.139,0,236.842 c0,27.348,4.693,53.588,13.219,78.026c0.079,0.221,0.15,0.445,0.228,0.673c32.452,92.102,120.19,158.135,223.387,158.135 c7.173,0,14.263-0.352,21.274-0.98c36.401-19.954,59.227-83.359,68.423-157.829C332.788,264.208,332.747,208.466,326.412,157.874z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EC1C24"
    },
    cx: 236.85,
    cy: 236.85,
    r: 87.25
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagJapan);
export default __webpack_public_path__ + "static/media/flag-japan.9688eca342e7746dd0f4b5d26b97bfea.svg";
export { ForwardRef as ReactComponent };